(function() {
    // --- CONFIGURATION ---
    // Note: The script reads the actual limit from data attributes, but we use 5 as a fallback.
    const DEBOUNCE_DELAY = 1000; // Delay to allow theme's JS to update input values first
    let threshold_limit = document.querySelector(".product__quantity");
    let limit = threshold_limit?.dataset?.limit == "" ? null : parseInt ( threshold_limit?.dataset?.limit );
    let PRODUCT_LIMITS = {}; 
    let delegateListenerAttached = false;
    
    const getCartData = async () => {
        try {
            const response = await fetch('/cart.js');
            return await response.json();
        } catch (error) {
            console.error('Error fetching cart data:', error);
            return { items: [] };
        }
    };

    // =================================================================
    // PDP LOGIC (Add to Cart Validation)
    // =================================================================

    const initPDPValidation = async () => {
      // Find the Add to Cart form
      console.log("pdp init",)
      const form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;
        

      const add_to_cart_main = document.querySelector('button[name="add"]');
      const add_to_cart_btn = document.querySelector('button[name="add"]');
      const add_to_cart_inc = document.querySelector('#mainqntt .inc');
    //   console.log("addddds", add_to_cart)
    //   console.log("addddds", add_to_cart.querySelector(".inc"))
      //   form.addEventListener('submit', async (event) => {
        const radioSub = document.querySelector('.radio_rtx[value="subsave"]');
        const isSubscriptionSelected = radioSub && radioSub.checked; 
        console.log("pdp init", isSubscriptionSelected)

        let warningDiv = document.getElementById('subscription-limit-warning');
            if (!warningDiv) {
                // 1. Create the warning div if it doesn't exist
                warningDiv = document.createElement('div');
                warningDiv.id = 'subscription-limit-warning';
                // Apply basic inline styles for visibility and separation
                warningDiv.style.color = 'red'; 
                // warningDiv.style.fontWeight = 'bold';
                // warningDiv.style.padding = '10px 0';
                
                // 2. Insert the warning message immediately before the Add to Cart button
                // add_to_cart_btn.parentNode.insertBefore(warningDiv, add_to_cart_btn);
                add_to_cart_btn.insertAdjacentElement("afterend", warningDiv);
            }
            // Set the warning text and ensure it's visible
            warningDiv.textContent = `Max threshold limit is ${limit}.`;
            warningDiv.style.display = 'none';

        // Exit if not a subscription purchase
        if (!isSubscriptionSelected) {
            add_to_cart_inc.disabled = false;
            // add_to_cart.style.backgroundColor = ''; 
            // add_to_cart.style.color = '';             
            // add_to_cart.style.opacity = '';           
            add_to_cart_inc.style.cursor = '';
            add_to_cart_inc.style.pointerEvents = '';

            add_to_cart_main.disabled = false;
            add_to_cart_main.style.backgroundColor = ''; 
            add_to_cart_main.style.color = '';             
            add_to_cart_main.style.opacity = '';           
            add_to_cart_main.style.cursor = '';
            if (warningDiv) {
                     warningDiv.style.display = 'none';
            }
            return; 
        } 
            
            
            const quantityInput = document.querySelector('input[name="quantity"]');
            const newQty = parseInt(quantityInput ? quantityInput.value : 1);
            
            const productSection = document.querySelector('select[name="id"]'); 
            const productId = parseInt(productSection?.dataset?.productid);  

            const cart = await getCartData();

            // const currentItemsOfProduct = cart.items.filter(item => item.product_id === productId && item.properties && item.properties.purchase_type == 'subscription' );
            const currentItemsOfProduct = cart.items.filter(item => item.product_id === productId && item?.selling_plan_allocation && item?.selling_plan_allocation?.selling_plan?.recurring_deliveries == true );
            console.log("currenItemProducts", currentItemsOfProduct)

            const currentQtyInCart = currentItemsOfProduct.reduce((total, item) => {
                return total + item.quantity;
            }, 0); // Start the accumulation at 0

           
            const totalQty = currentQtyInCart + newQty;



           
            if (totalQty > limit) {

                

                add_to_cart_main.disabled = true;
                add_to_cart_main.style.backgroundColor = '#808080'; 
                add_to_cart_main.style.color = '#ffffff';             
                add_to_cart_main.style.opacity = '0.9';           
                add_to_cart_main.style.cursor = 'not-allowed';      
                      
                add_to_cart_inc.disabled = true;  
                // 2. Apply explicit styles to override the theme's appearance
                // add_to_cart.style.backgroundColor = '#808080'; // Gray background
                // add_to_cart.style.color = '#ffffff';             // White text
                // add_to_cart.style.opacity = '0.9';               // Ensure it looks solid
                add_to_cart_inc.style.cursor = 'not-allowed';        // Show the 'no-entry' cursor
                add_to_cart_inc.style.pointerEvents = 'none';
                warningDiv.style.display = 'ruby-text';
        
            } 
            else {
                add_to_cart_inc.disabled = false;
                // add_to_cart.style.backgroundColor = ''; // Reset
                // add_to_cart.style.color = '';             // Reset
                // add_to_cart.style.opacity = '';           // Reset
                add_to_cart_inc.style.cursor = '';    
                add_to_cart_inc.style.pointerEvents = '';

                add_to_cart_main.disabled = false;
                add_to_cart_main.style.backgroundColor = ''; 
                add_to_cart_main.style.color = '';             
                add_to_cart_main.style.opacity = '';           
                add_to_cart_main.style.cursor = '';

                // Validation passed: Submit via AJAX
                const formData = new FormData(form); 
                if (warningDiv) {
                     warningDiv.style.display = 'none';
                }
 
            }
        // });
    };

    const cart_update = ( itemKey, newQty ) => { 
         // 3. AJAX UPDATE (Only run if quantity has changed or needs correcting)
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                id: itemKey, // Use 'id' for item key in /cart/change.js
                quantity: newQty 
            })
        })
        .then(response => response.json())
        .then(cart => {  
            const items = document.querySelectorAll('[data-key]');
            items.forEach(itemContainer => {
                console.log("qty trigger", itemContainer.dataset)
                const productId = (itemContainer.dataset.product_id); 
                const itemKey = itemContainer.dataset.key;
                
                // 1. Find the corresponding item in the new cart data using its unique key
                const lineItem = cart.items.find(item => item.key == itemKey);
                
                // const isSubscriptionItem = lineItem?.properties && (lineItem?.properties?.purchase_type === 'subscription')
                const isSubscriptionItem = lineItem?.selling_plan_allocation && lineItem?.selling_plan_allocation?.selling_plan?.recurring_deliveries == true
                
                
                console.log("cart re initn123", itemContainer.dataset)
                if ( isSubscriptionItem ) {
                    itemContainer.dataset.limit = PRODUCT_LIMITS[productId]; // ⬅️ Writes data-limit="5"
                    itemContainer.dataset.is_subscription = true; // ⬅️ Writes data-limit="5"
                }   

                updateCartItemUI(itemContainer, cart); 
            } );
           
        })
        .catch(error => console.error('Error changing cart quantity:', error));
    }

    const validateAndChangeCartQty = async (itemContainer) => {
        const isSubscription = itemContainer.dataset.is_subscription === 'true';
        
        const productId = parseInt(itemContainer.dataset.product_id);
        
        const itemKey = itemContainer.dataset.key; // Unique cart item key
        const quantityInput = itemContainer.querySelector('input[name="updates[]"]');
        let newQty = parseInt(quantityInput.value);
        
        
        const productLimit = itemContainer?.dataset?.limit == "" ? null : parseInt( itemContainer?.dataset?.limit );
        console.log("qty trigger", newQty)
        
        
        // if (!isSubscription) return;

        if ( !productLimit || !isSubscription ) {

            cart_update( itemKey, newQty );
            return ;
        }  

        const cart = await getCartData();
        const otherVariantsQty = cart.items
            .filter(item => 
                item.product_id === productId && 
                item.key !== itemKey 
                && // Exclude the current item
                item?.selling_plan_allocation && item?.selling_plan_allocation?.selling_plan?.recurring_deliveries == true
                // item.properties && 
                // item.properties.purchase_type == 'subscription'
            )
            .reduce((total, item) => total + item.quantity, 0);

        const maxAllowedForCurrentVariant = productLimit - otherVariantsQty; 
        if (newQty > maxAllowedForCurrentVariant) {
            // Cap the quantity for the current variant
            newQty = Math.max(1, maxAllowedForCurrentVariant); 
            quantityInput.value = newQty; 
            console.log(`Product ${productId} total capped at limit ${productLimit}. Corrected variant ${itemKey} quantity to ${newQty}.`);
        }

        cart_update( itemKey, newQty );

    };

    const extractProductLimits = (cartItems) => {
        cartItems.forEach(itemContainer => {
            // Check if the item is a subscription and has product ID/limit attributes
            const isSubscription = itemContainer.dataset.is_subscription === 'true';
            const productId = (itemContainer.dataset.product_id); 
            const productLimit = itemContainer?.dataset?.limit == "" ? null : parseInt( itemContainer?.dataset?.limit ); // Uses 'data-data-limit' from your image

            if (isSubscription && !isNaN(productId) && !isNaN(productLimit)) {
                // Store the limit for the product ID
                PRODUCT_LIMITS[productId] = productLimit; 
            }
        });
    };

     const updateCartItemUI = (itemContainer, cartData) => {
         const isSubscription = itemContainer.dataset.is_subscription === 'true';
         const productId = parseInt(itemContainer.dataset.product_id);
         const itemKey = itemContainer.dataset.key;
         
         console.log("cart init before", isSubscription, isNaN(productId))
         if (!isSubscription || isNaN(productId)) return; 
         const cart_item_limit = PRODUCT_LIMITS[productId];
         console.log("cart_item_limit", cart_item_limit)
         
         const incButton = itemContainer.querySelector('.js-qty__adjust--plus');
         console.log("cart init limit", incButton)
         if (!incButton || !cart_item_limit) return;
         
         // 1. Calculate current total subscription quantity for this PRODUCT
         const currentItemsOfProduct = cartData.items.filter(item => 
            item.product_id == productId 
            && 
            item?.selling_plan_allocation && item?.selling_plan_allocation?.selling_plan?.recurring_deliveries == true
            // item.properties && 
            // item.properties.purchase_type == 'subscription' // Check for a subscription property
        );
        
        const currentQtyInCart = currentItemsOfProduct.reduce((total, item) => total + item.quantity, 0);
        console.log("cart aftr", typeof currentQtyInCart)
        
        if ( isSubscription ) {
            itemContainer.dataset.limit = PRODUCT_LIMITS[productId]; // ⬅️ Writes data-limit="5"
            itemContainer.dataset.is_subscription = true; // ⬅️ Writes data-limit="5"
        }   
            const mainQNTTDiv = itemContainer.querySelector('.js-qty__wrapper');
            console.log("maindev", mainQNTTDiv)
            const cart_items_name = itemContainer.querySelector('.cart__item--details');
            const mainQNTTDiv_input = itemContainer.querySelector('.js-qty__wrapper input');
            let warningDiv = document.getElementById(`subscription-limit-warning-${itemKey}`);
            if (!warningDiv) {
                // 1. Create the warning div if it doesn't exist
                warningDiv = document.createElement('div');
                warningDiv.id = `subscription-limit-warning-${itemKey}`;
                // Apply basic inline styles for visibility and separation
                warningDiv.style.color = 'red'; 
                
                // 2. Insert the warning message immediately before the Add to Cart button
                mainQNTTDiv.parentNode.insertBefore(warningDiv, mainQNTTDiv.nextSibling);
            }
            // Set the warning text and ensure it's visible
            warningDiv.textContent = `Max threshold limit is ${PRODUCT_LIMITS [ productId ]}.`;
            warningDiv.style.display = 'none';
            
            console.log("mainQNTTDiv_input", mainQNTTDiv_input)
            if ( mainQNTTDiv_input.value >= PRODUCT_LIMITS [ productId ]) {
                mainQNTTDiv_input.value = PRODUCT_LIMITS [ productId ];
                warningDiv.style.display = 'none';
            }

        if (currentQtyInCart >= cart_item_limit) { 
            // Disable the increment button if we are at or over the limit
            console.log("update cart UI true", currentQtyInCart)
            incButton.disabled = true;
            incButton.style.opacity = '0.5';
            incButton.style.cursor = 'not-allowed';
            warningDiv.style.display = 'block';
        } else {
            console.log("update cart UI else", currentQtyInCart)
             // Enable the increment button
             incButton.disabled = false;
             incButton.style.opacity = '';
             incButton.style.cursor = '';
             warningDiv.style.display = 'none';
        }


    };

    const handleCartQuantityClick = (event) => {
        // Find the button that was clicked
        const clickedButton = event.target.closest('.js-qty__adjust--plus, .js-qty__adjust--minus');
        
        if (!clickedButton) return;
        
        const itemContainer = clickedButton.closest('[data-key]');
        
        if (!itemContainer) {
            console.error("Could not find parent cart item container for the clicked button.");
            return;
        }
        
        setTimeout(() => {
            validateAndChangeCartQty(itemContainer);
        }, DEBOUNCE_DELAY);
    };

    const initCartListeners = async (container = document) => {
        console.log("cart init")
        const cartItems = container.querySelectorAll('[data-key]');

        extractProductLimits(cartItems);

        const cartData = await getCartData();
        
        cartItems.forEach(itemContainer => {
            const productId = parseInt(itemContainer.dataset.product_id);


            const quantityInput = itemContainer.querySelector('input[name="updates[]"]');
            if (!quantityInput) return;

            updateCartItemUI(itemContainer, cartData); 

            
            const mainQNTTDiv = itemContainer.querySelector('.js-qty__wrapper');
            const cart_items_name = itemContainer.querySelector('.cart__item--details');
            const mainQNTTDiv_input = itemContainer.querySelector('.js-qty__wrapper input');
            const decButton = itemContainer.querySelector('.js-qty__adjust--minus');
            const incButton = itemContainer.querySelector('.js-qty__adjust--plus');
            console.log("cart_items_name", cart_items_name)
        
            
            const handler = () => validateAndChangeCartQty(itemContainer);

 

        if (!delegateListenerAttached) {
            console.log("clecik for second time")
            
            document.body.addEventListener('click', handleCartQuantityClick);

            delegateListenerAttached = true;
        }
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        if ( window.location.pathname.includes('/cart') ) {
            initCartListeners(); 
        }
        if ( !limit ) return;
        
        const form = document.querySelector('form[action="/cart/add"]');
        if (!form) return;
        
      
        const radioButtons = form.querySelectorAll('input.radio_rtx[name="selling_plan_select"]'); 

        // The handler function that runs your validation logic
        const handler = () => {
            console.log(" otion change")
            const radioSub = document.querySelector('.radio_rtx[value="subsave"]');
            const isSubscriptionSelected = radioSub && radioSub.checked; 
            if ( isSubscriptionSelected ) {
                const input_val = document.querySelector('#mainqntt input');
                input_val.value = limit;
                console.log("input_val", input_val.value);
            }
            
            initPDPValidation();
        };

        if (radioButtons.length > 0) {
            radioButtons.forEach(radio => {
                // The 'change' event fires when a radio button's selection status is altered.
                radio.addEventListener('change', handler); 
            });
        }


        initPDPValidation();
        const quantityContainer = document.getElementById('mainqntt');
        if (!quantityContainer) return;
        
        const quantityInput = quantityContainer.querySelector('input[name="quantity"]');
        const decButton = quantityContainer.querySelector('.dec.qntnbtn');
        const incButton = quantityContainer.querySelector('.inc.qntnbtn');
        
        if (!quantityInput || !decButton || !incButton) return;
        
        // 2. Define the handler function for when the quantity actually changes
        const handleQuantityChange = (action) => {
            // You can get the new value here
            const newQuantity = parseInt(quantityInput.value); 

            initPDPValidation(); 
        };
        
        // 3. Attach listeners to the buttons
        incButton.addEventListener('click', () => {
            console.log("qty change")
            // Use a slight delay to ensure the theme's JS has fully updated the input's .value
            // setTimeout(() => handleQuantityChange('increase'), 50); 
            handleQuantityChange('increase')
        });
        
        decButton.addEventListener('click', () => {
            console.log("qty change")
            // setTimeout(() => handleQuantityChange('decrease'), 50);
            handleQuantityChange('decrease')
        });

        const addToCartForm = document.querySelector('form[action="/cart/add"]');

        if (addToCartForm) {
            addToCartForm.addEventListener('submit', async (e) => {
                e.preventDefault(); // stop Shopify’s default form submit

                const formData = new FormData(addToCartForm);

                // check subscription radio
                const radioSub = document.querySelector('.radio_rtx[value="subsave"]');
                const isSubscriptionSelected = radioSub && radioSub.checked;
                // let product_type = isSubscriptionSelected ? subscription' : 'one-time'
                console.log("isSubscriptionSelected", limit)
                // append property
                // if ( isSubscriptionSelected ) {
                //     formData.append('properties[purchase_type]', "subscription" ); 
                //     formData.append('properties[limit]', limit ); 
                // }

                // send to Shopify
                await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
                })
                // optional: trigger cart drawer or page refresh
                document.dispatchEvent(new CustomEvent('cart:add:success', { bubbles: true }));
                initPDPValidation()
            });
        }

        //cart drawer
        // Ensure Rebuy's module is available before trying to attach listeners
        
        // document.addEventListener('rebuy:cart.ready', (event) => { 
        //     console.log('rebuy:cart.ready event', event.detail); 

        //     // document.addEventListener('rebuy:smartcart.show', (event) => {
        //     //     console.log('Rebuy Smart Cart is open', event.detail.smartcart);
        //     //     // Add your custom logic here, such as sending an analytics event
        //     //     // or triggering another custom action.
        //     // });
        // });
            //         // Listen for the cart to be shown (opened)



            const initRebuyLimitValidation = async(rebuyCartElement, updatedCartData) => {
                // if (!updatedCartData ) return;
                // if (!updatedCartData || !updatedCartData.item) return;
                
                // Get all visible item <li> elements
                const lineItemElements = rebuyCartElement.querySelectorAll(
                    'ul[data-smartcart-items] > li.rebuy-cart__flyout-item'
                );
                
                console.log("draer callled>>", lineItemElements.length)
                const cartData = await getCartData(); 
                lineItemElements.forEach(itemContainer => {
                    
                    
                    console.log("chnge triggerl", itemContainer);
                        if (itemContainer?.dataset?.is_subscription == "true") {
                            
                            const productId = itemContainer?.dataset?.product_id;
                            const limitString = itemContainer?.dataset?.limit;
                            const cart_item_limit = parseInt(limitString);
                            const itemKey = itemContainer.dataset.item_key;
                            console.log("itemContainer.dataset", itemContainer.dataset)

                            

                            // B. Calculate TOTAL Subscription Quantity for this Product ID
                            //    -> Filters by product_id AND the subscription property.
                            // const currentQtyInCart = updatedCartData.item
                            const currentQtyInCart = cartData.items
                            .filter(item => 
                                // 1. Match the Product ID (covers all variants of this product)
                                    item.product_id == productId && 
                                    item?.selling_plan_allocation && item?.selling_plan_allocation?.selling_plan?.recurring_deliveries == true
                                    
                                )
                                .reduce((total, item) => total + item.quantity, 0);
                                 
                            // C. Get the Increase Button Element
                            const incButton = itemContainer.querySelector(
                                '.rebuy-cart__flyout-item-quantity-widget-button:last-child'
                            );

                            const mainQNTTDiv = itemContainer.querySelector('.rebuy-cart__flyout-item-quantity-widget');
                            console.log("maindev", mainQNTTDiv)
                            const cart_items_name = itemContainer.querySelector('.cart__item--details');
                            const mainQNTTDiv_input = itemContainer.querySelector('.js-qty__wrapper input');
                            let warningDiv = document.getElementById(`subscription-limit-warning-drawer-${itemKey}`);
                            if (!warningDiv) {
                                // 1. Create the warning div if it doesn't exist
                                warningDiv = document.createElement('div');
                                warningDiv.id = `subscription-limit-warning-drawer-${itemKey}`;
                                // Apply basic inline styles for visibility and separation
                                warningDiv.style.color = 'red'; 
                                // warningDiv.style.fontWeight = 'bold';
                                // warningDiv.style.padding = '10px 0';
                                console.log("warningDiv", warningDiv)
                                
                                // 2. Insert the warning message immediately before the Add to Cart button
                                mainQNTTDiv.parentNode.insertBefore(warningDiv, mainQNTTDiv.nextSibling);
                                
                            }
                            // Set the warning text and ensure it's visible
                            warningDiv.textContent = `Max threshold limit is ${cart_item_limit}.`;
                            warningDiv.style.display = 'none';
                            console.log("mainQNTTDiv create", mainQNTTDiv)
                            // D. Apply Limit Logic
                            if (incButton && !isNaN(cart_item_limit)) {
                                console.log("drawers", currentQtyInCart >= cart_item_limit, incButton, cart_item_limit )
                                if (currentQtyInCart >= cart_item_limit) { 
                                    incButton.disabled = true;
                                    incButton.style.opacity = '0.5';
                                    incButton.style.cursor = 'not-allowed';
                                    warningDiv.style.display = 'block';

                                } else {
                                    incButton.disabled = false;
                                    incButton.style.opacity = '';
                                    incButton.style.cursor = '';
                                    warningDiv.style.display = 'none';

                                }
                            }
                        }
                    });
                    //call the pdp
                        if ( window.location.pathname.includes('/products') ) {
                            initPDPValidation();
                        }

                };

            document.addEventListener('rebuy:cart.add', (event) => { 
                // console.log('rebuy:cart.add event', event.detail); 
                
                const rebuyCartElement = document.querySelector("#rebuy-cart");
                const updatedCartData = event.detail;

                if (rebuyCartElement && updatedCartData) {
                    // Run the validation logic immediately
                    initRebuyLimitValidation(rebuyCartElement, updatedCartData);
                }
            });
            
            document.addEventListener('rebuy:cart.change', (event) => { 
                const rebuyCartElement = document.querySelector("#rebuy-cart");
                const updatedCartData = event.detail;
                
                if (rebuyCartElement && updatedCartData) {
                    console.log("vhnage trigger")
                    // Run the validation logic immediately
                    initRebuyLimitValidation(rebuyCartElement, updatedCartData);
                }
            });

            document.addEventListener('rebuy:smartcart.show', function(event) {
                const rebuyCartElement = document.querySelector("#rebuy-cart");
                const updatedCartData = event.detail;
                
                console.log("side  trigger open")
                if (rebuyCartElement && updatedCartData) {
                    // Run the validation logic immediately
                    initRebuyLimitValidation(rebuyCartElement, updatedCartData);
                }
            });
})
})();